
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import SearchBoxModal from "../component/SearchBoxModal";
import { checkRole } from "../model";
import SerchBoxMulti from "../component/SerchBoxMulti";
import ModalSearchMulti from "../component/ModalSearchMulti";

export default function FormParts() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const rolesAllCompany = checkRole(user, 'list-users', 'viewallcompany');
    const rolesAll = checkRole(user, 'list-users', 'viewall');

    const defaultdetail = {
        company_id: '', parent_id: 0, author_id: user.data.id, shortname: '', title: '', vanthu: '', master_id: '', kyphu: '', kytotrinh: '', status: 1,
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "parts/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                let detailf = res.data.data
                                detailf.kyphu = detailf.kyphu ? JSON.parse(detailf.kyphu) : []
                                detailf.manager_ungvien = detailf.manager_ungvien ? JSON.parse(detailf.manager_ungvien) : []
                                detailf.manager_user = detailf.manager_user ? JSON.parse(detailf.manager_user) : []
                                setDetail(detailf);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tên phòng ban').max(150, "Độ dài không quá 150 ký tự")
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'parts/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật phòng ban thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                // console.log(values);
                Axios.post(URL_LIST_ALL + 'parts', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới phòng ban thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="list-parts">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/list-parts">Quản lý phòng ban</Link>
                    </li>
                    <li>{id ? 'Sửa phòng ban' : 'Thêm mới phòng ban'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Phòng ban</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-4 form-group">
                                <label>Tên phòng ban <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-4 form-group">
                                <label>Tên rút gọn</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("shortname")} autoComplete="off" />

                            </div>
                            <div className="col-12 col-sm-4 form-group">
                                <label>Phòng ban cha:</label>
                                <SearchBoxModal apiname={"parts"} alldata={"?status=1"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} defaultValue={formik.values['parent_id']} name='parent_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('parent_id', e)
                                    }}></SearchBoxModal>

                            </div>
                            <div className="col-xs-12"></div>

                            {rolesAllCompany || rolesAll ?
                                <div className="col-12 col-sm-6 form-group">
                                    <label>Công ty </label>
                                    <SearchBoxModal apiname={"company"} placeholder="Chọn công ty" colvalue={'id'} colname={'title'} defaultValue={formik.values['company_id']} name='company_id'
                                        onChange={async (e) => {
                                            await formik.setFieldValue('company_id', e)
                                        }}></SearchBoxModal>
                                    <AlertErrorForm formik={formik} name="company_id"></AlertErrorForm>
                                </div>
                                :
                                <input type="hidden" placeholder="" className="form-control height32" {...formik.getFieldProps("company_id")} />
                            }
                            <div className="col-12 col-sm-6 form-group">
                                <label>Trạng thái</label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="0">Khoá</option>
                                    <option value="1">Hoạt động</option>
                                </select>
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Người quản lý: </label>
                                <SearchBoxModal apiname={"users"} alldata={"?limit=1000&status=1;2;4;5;6"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['master_id']} name='master_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('master_id', e)
                                    }}></SearchBoxModal>
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Ký tờ trình:</label>
                                <SearchBoxModal apiname={"users"} alldata={""} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['kytotrinh']} name='kytotrinh'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('kytotrinh', e)
                                    }}></SearchBoxModal>

                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Người ký phụ: </label>
                                <SerchBoxMulti apiname={"users"} alldata={"?limit=1000&status=1;2;4;5;6"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['kyphu']} name='kyphu'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('kyphu', e)
                                    }}></SerchBoxMulti>
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Ai có thêm quyền quản lý ứng viên: </label>
                                <ModalSearchMulti apiname={"users"} multiple={true} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'}
                                    defaultValue={formik.values['manager_ungvien']} name='manager_ungvien'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('manager_ungvien', e)
                                    }}></ModalSearchMulti>
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Ai có thêm quyền quản lý nhân sự trong phòng/ban này: </label>
                                <ModalSearchMulti apiname={"users"} multiple={true} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'}
                                    defaultValue={formik.values['manager_user']} name='manager_user'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('manager_user', e)
                                    }}></ModalSearchMulti>
                            </div>
                            {id > 0 &&
                                <div className="col-12 col-sm-6 form-group">
                                    <label>Người cấp số văn thư:</label>
                                    <SearchBoxModal apiname={"users"} alldata={""} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['vanthu']} name='vanthu'
                                        onChange={async (e) => {
                                            await formik.setFieldValue('vanthu', e)
                                        }}></SearchBoxModal>

                                </div>
                            }

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
